<template>
  <vx-card class="list-view-item overflow-hidden" :class="{ 'list-view-item--vip': isVip }" v-on="$listeners">
    <template slot="no-body">
      <div class="plan-card-body">
        <div class="plan-card-main">
          <div class="plan-card-radio" aria-hidden="true">
            <span class="plan-card-radio__dot"></span>
          </div>
          <div class="plan-card-meta">
            <slot name="item-meta">
              <div class="plan-card-title-row">
                <h6 class="item-name font-semibold mb-0">{{ item.name }}</h6>
                <span v-if="isVip" class="plan-card-badge">VIP</span>
              </div>
              <p class="item-description text-sm mb-0">{{ item.description }}</p>
            </slot>
          </div>
        </div>

        <div class="plan-card-price">
          <template v-if="item.setup_fee > 0">
            <div class="plan-card-price__setup">
              Adesão <strong>{{ item.setup_fee | money(item.currency_code) }}</strong>
            </div>
            <div class="plan-card-price__value">
              {{ item.fixed_price | money(item.currency_code) }}
              <span class="plan-card-price__period">/mês</span>
            </div>
          </template>
          <template v-else>
            <div class="plan-card-price__value">
              {{ item.fixed_price | money(item.currency_code) }}
            </div>
            <div class="plan-card-price__hint" v-if="item.recurring">pagamento recorrente</div>
            <div class="plan-card-price__hint" v-else>pagamento único</div>
          </template>
          <slot name="action-buttons" />
        </div>
      </div>
    </template>
    <div class="plan-card-details" v-if="$slots['plan-selected']">
      <slot name="plan-selected" />
    </div>
  </vx-card>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isVip() {
      return this.item && this.item.name && String(this.item.name).toLowerCase().includes('vip');
    }
  }
};
</script>

<style lang="scss" scoped>
.list-view-item {
  border-radius: 12px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;

  .plan-card-body {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 1rem;
    padding: 1.25rem 1.25rem 1rem;
  }

  .plan-card-main {
    display: flex;
    align-items: flex-start;
    gap: 0.85rem;
    flex: 1 1 220px;
    min-width: 0;
  }

  .plan-card-radio {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 2px solid #cfcfcf;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
    transition: border-color 0.15s ease, background 0.15s ease;

    .plan-card-radio__dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: transparent;
      transition: background 0.15s ease;
    }
  }

  .plan-card-title-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 0.35rem;
  }

  .plan-card-badge {
    display: inline-flex;
    align-items: center;
    padding: 0.15rem 0.5rem;
    border-radius: 999px;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: #5c3498;
    background: rgba(92, 52, 152, 0.12);
  }

  .plan-card-price {
    flex: 0 1 180px;
    text-align: right;
    margin-left: auto;
  }

  .plan-card-price__value {
    font-size: 1.35rem;
    font-weight: 700;
    color: #2c2c2c;
    line-height: 1.2;
  }

  .plan-card-price__period,
  .plan-card-price__hint {
    font-size: 0.8rem;
    font-weight: 500;
    color: #8a8a8a;
  }

  .plan-card-price__setup {
    font-size: 0.85rem;
    color: #626262;
    margin-bottom: 0.25rem;
  }

  .plan-card-details {
    border-top: 1px solid rgba(92, 52, 152, 0.1);
    padding: 1.1rem 1.25rem 1.35rem;
    background: linear-gradient(180deg, #faf8fc 0%, #f3effa 100%);
  }

  .item-name,
  .item-description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .item-name {
    -webkit-line-clamp: 2;
    font-size: 1.05rem;
  }

  .item-description {
    -webkit-line-clamp: 3;
    color: #6b6b6b;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 28px rgba(49, 28, 84, 0.1);
  }

  &--vip {
    .plan-card-badge {
      color: #fff;
      background: linear-gradient(145deg, #5c3498, #7a4fc0);
    }
  }
}
</style>
